// extracted by mini-css-extract-plugin
export default {"matchStats":"MatchStats_matchStats__YbpK6","notAvailable":"MatchStats_notAvailable__p36pP"};